import { NgModule } from '@angular/core';
import { FormControlErrorMessagesDirective } from './form-control-error-messages.directive';
import { FormSubmitDirective } from './form-submit.directive';

/**
 * It makes sense to group these in a module despite them being standalone directives
 * because the moment a developer adds the `FormControlErrorMessagesDirective`,
 * they likely want the `FormSubmitDirective` to be active as well.
 *
 * `ControlErrorContainerDirective` is not included because in most cases it is not needed
 * and can easily be imported directly otherwise.
 *
 * If you do not want `FormSubmitDirective` to be active for some reason,
 * just import `FormControlErrorMessagesDirective` directly instead of importing this module.
 */
@NgModule({
    imports: [FormControlErrorMessagesDirective, FormSubmitDirective],
    exports: [FormControlErrorMessagesDirective, FormSubmitDirective],
})
export class FormErrorsModule {}
